"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const Button_1 = __importDefault(require("../../components/Button"));
const IconType_1 = __importDefault(require("../../components/enums/IconType"));
const IdHeader_1 = __importDefault(require("../../components/IdHeader"));
const IllustrationNoDrawing_1 = __importDefault(require("../../components/illustrations/IllustrationNoDrawing"));
const ForgotPasswordEmailSent_1 = __importDefault(require("../../components/popups/ForgotPasswordEmailSent"));
const TextInput_1 = __importDefault(require("../../components/TextInput"));
const ForgotPassword = () => {
    //Screen State Variables
    const [isDone, setIsDone] = (0, react_1.useState)(false);
    const [isFormFilled, setIsFormFilled] = (0, react_1.useState)(false);
    //Form Variables
    const [email, setEmail] = (0, react_1.useState)("");
    //Error states
    const [emailError, setEmailError] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        if (email.length !== 0) {
            setIsFormFilled(true);
        }
        else {
            setIsFormFilled(false);
        }
    }, [email]);
    const handleResetEvent = (e) => {
        e.preventDefault();
        setIsDone(false);
        setEmailError("");
        fetch("/forgot-password", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: email,
            }),
        })
            .then((response) => {
            response
                .json()
                .then((content) => {
                if (!content.success) {
                    if (content.response.message == "invalid_fields") {
                        setEmailError("Invalid email address");
                    }
                    return false;
                }
                setIsDone(true);
            })
                .catch(() => { });
        })
            .catch(() => { });
    };
    return (react_1.default.createElement("div", { className: isDone === true ? "forgot-password-withpopup" : "" },
        react_1.default.createElement(IdHeader_1.default, { hideBackButton: true, handlerFunction: function () {
                throw new Error("Function not implemented.");
            } }),
        react_1.default.createElement("main", { className: "forgot-password" },
            react_1.default.createElement("section", { className: "forgot-password__content" },
                react_1.default.createElement("div", { className: "forgot-password__form-container" },
                    react_1.default.createElement("h1", { className: "forgot-password__title" }, "Reset your password"),
                    react_1.default.createElement("form", { className: "forgot-password__form", onSubmit: handleResetEvent, method: "post" },
                        react_1.default.createElement(TextInput_1.default, { label: "Email", name: "email", value: email, onChangeHandler: setEmail, placeholder: "Enter the email address you registered with", isRequired: true, type: "email", state: emailError == "" ? "normal" : "error", errorText: emailError, unit: "" }),
                        react_1.default.createElement(Button_1.default, { state: isFormFilled ? "enabled" : "disabled", label: "Reset password", type: "primary", icon: IconType_1.default.None, handlerFunction: () => { }, action: "submit" })))),
            react_1.default.createElement("div", { className: "forgot-password__illustration" },
                react_1.default.createElement("h1", { className: "forgot-password__title-mobile" }, "Reset passwod"),
                react_1.default.createElement(IllustrationNoDrawing_1.default, null,
                    react_1.default.createElement(react_1.default.Fragment, null)))),
        isDone === true ? (react_1.default.createElement(ForgotPasswordEmailSent_1.default, { closeFunction: () => setIsDone(false), email: email })) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.default = ForgotPassword;
if (document.getElementById("guest-forgot-password")) {
    (0, client_1.createRoot)(document.getElementById("guest-forgot-password")).render(react_1.default.createElement(ForgotPassword, null));
}
